import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '@hellodarwin/core/lib/components/common/typography';
import Tooltip from 'antd/es/tooltip';
import { useTheme } from 'styled-components';
import { AcceptedApplicationRowContainer, AcceptedApplicationRowLabelContainer, AcceptedApplicationRowValue, } from './styles';
const AcceptedApplicationRow = ({ Icon, label, value, }) => {
    const theme = useTheme();
    return (_jsxs(AcceptedApplicationRowContainer, { children: [_jsxs(AcceptedApplicationRowLabelContainer, { children: [_jsx(Icon, { size: 16, color: theme.colors.grey_2 }), _jsx(Tooltip, { title: label, children: _jsx(Typography, { elementTheme: "overline", color: theme.colors.grey_2, style: {
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }, children: label }) })] }), _jsx(AcceptedApplicationRowValue, { elementTheme: "body3", color: theme.colors.grey_1, children: value })] }));
};
export default AcceptedApplicationRow;
